import React, { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import axios from "axios";
import { useNavigate, useOutletContext } from "react-router-dom";
import toastr from "toastr";
import $ from "jquery";


function AddSearchProposal({ show, onClose,onSuccess }) {
  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      key_attributes: [{ value: "" }, { value: "" }, { value: "" }],
    },
  });

  const {
    fields: keyAttributes,
    append,
    remove,
  } = useFieldArray({
    control,
    name: "key_attributes",
  });

  const navigate = useNavigate();
  const { token, setGlobalLoading } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [clients, setClients] = useState([]);
  const [roleManagers, setRoleManagers] = useState([]);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [dutymasters, setDutymasters] = useState([]);
  const [duties, setDuties] = useState([]);
  const [nextReference, setNextReference] = useState("");
  const [filteredRegions, setFilteredRegions] = useState([]);
  const [filteredDuties, setFilteredDuties] = useState([]);

  useEffect(() => {
    if (!show) return;

    const fetchDropdownData = async () => {
      try {
        setGlobalLoading(false);
        const res = await axios.get(
          `${API_BASE_URL}/roles/searchproposallist/`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setClients(res.data.clients || []);
        setRoleManagers(res.data.role_managers || []);
        setCountries(res.data.countries || []);
        setRegions(res.data.regions || []);
        setDutymasters(res.data.dutymasters || []);
        setDuties(res.data.duties || []);
        // 👇 Extract and set the next reference number
        // Safely extract reference number
        const latestReference =
          typeof res.data.reference === "number"
            ? res.data.reference
            : parseInt(res.data.reference?.reference || 0);

        const nextRef = latestReference + 1;

        setNextReference(nextRef); // for displaying
        setValue("reference", nextRef); // for form submission
      } catch (err) {
        console.error("Failed to load dropdown data:", err);
      } finally {
        setGlobalLoading(false);
      }
    };

    fetchDropdownData();
  }, [show]);
  const handleCountryChange = (e) => {
    const selectedCountryId = e.target.value;
    setValue("countries", selectedCountryId, { shouldValidate: true });

    const country = countries.find((c) => c.id === parseInt(selectedCountryId));
    if (!country) {
      setFilteredRegions([]);
      return;
    }

    const matchingRegions = regions.filter((r) => r.id === country.region_id);
    setFilteredRegions(matchingRegions);
  };
  const handleDutymasterChange = (e) => {
    const selectedDutymasterId = e.target.value;
    setValue("dutymasters", selectedDutymasterId, { shouldValidate: true });

    const matchingDuties = duties.filter(
  (duty) =>
    parseInt(duty.dutymaster_id) ===
    parseInt(selectedDutymasterId)
);
    setFilteredDuties(matchingDuties);
  };

  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);
      console.log("📤 Submitting Search Proposal data:", data);

      await axios.post(`${API_BASE_URL}/roles/searchproposal/create`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toastr.success("Search Proposal added successfully.");
      if (onSuccess) {
      onSuccess();
}
      reset();
      onClose();
      setTimeout(() => navigate("/role/searchproposal"), 1000);
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Failed to submit search proposal.");
    } finally {
      setGlobalLoading(false);
    }
  };

useEffect(() => {
  if (!show) return;

  const $selects = $(".searchable-select");

  $selects.each(function () {
    const $select = $(this);

    if ($select.hasClass("select2-hidden-accessible")) {
      $select.select2("destroy");
    }

    $select.select2({
      width: "100%",
      placeholder: "Select",
      allowClear: true,
      dropdownParent: $select.parent(),
    });
  });

  // CLIENT
  const $client = $('[name="clients"]');

  $client.off("select2:select.searchProposal");
  $client.on("select2:select.searchProposal", function (e) {
    setValue("clients", e.params.data.id, {
      shouldValidate: true,
    });
  });

  // ROLE MANAGER
  const $roleManager = $('[name="roleManagers"]');

  $roleManager.off("select2:select.searchProposal");
  $roleManager.on("select2:select.searchProposal", function (e) {
    setValue("roleManagers", e.params.data.id, {
      shouldValidate: true,
    });
  });

  // COUNTRY
  const $country = $('[name="countries"]');

  $country.off("select2:select.searchProposal");
  $country.on("select2:select.searchProposal", function (e) {
    const value = e.params.data.id;

    // Use your EXISTING function
    handleCountryChange({
      target: {
        value: value,
      },
    });
  });

  // MAJOR FUNCTION
  const $majorFunction = $('[name="dutymasters"]');

  $majorFunction.off("select2:select.searchProposal");
  $majorFunction.on("select2:select.searchProposal", function (e) {
    const value = e.params.data.id;

    // Use your EXISTING function
    handleDutymasterChange({
      target: {
        value: value,
      },
    });
  });

  // FUNCTION
  const $function = $('[name="filteredDuties"]');

  $function.off("select2:select.searchProposal");
  $function.on("select2:select.searchProposal", function (e) {
    setValue("filteredDuties", e.params.data.id, {
      shouldValidate: true,
    });
  });

  return () => {
    $client.off(".searchProposal");
    $roleManager.off(".searchProposal");
    $country.off(".searchProposal");
    $majorFunction.off(".searchProposal");
    $function.off(".searchProposal");

    $selects.each(function () {
      const $select = $(this);

      if ($select.hasClass("select2-hidden-accessible")) {
        $select.select2("destroy");
      }
    });
  };
}, [
  show,
  clients,
  roleManagers,
  countries,
  dutymasters,
  filteredDuties,
]);

  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "800px" }}
      >
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h5 className="modal-title">Add Search Proposal</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>

            <div className="modal-body">
              <div className="row">
                {/* Reference on the left */}
                <div className="mb-3 col-md-6">
                  <label className="form-label">Reference ID</label>
                  <input
                    type="text"
                    className="form-control"
                    value={nextReference}
                    readOnly
                    {...register("reference")}
                  />
                </div>

                {/* Role Designation on the right */}
                <div className="mb-3 col-md-6">
                  <label className="form-label">Role Designation *</label>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.role_designation ? "is-invalid" : ""
                    }`}
                    placeholder="Enter role designation"
                    {...register("role_designation", {
                      required: "Role Designation is required",
                    })}
                  />
                  {errors.role_designation && (
                    <div className="invalid-feedback">
                      {errors.role_designation.message}
                    </div>
                  )}
                </div>
              </div>

              {/* Client + Role Manager */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">Client *</label>
                  <select
                    className={`form-select searchable-select ${
                      errors.clients ? "is-invalid" : ""
                    }`}
                    {...register("clients", {
                      required: "Client is required",
                    })}
                  >
                    <option value="">-- Select Client --</option>
                    {clients.map((client) => (
                      <option key={client.id} value={client.id}>
                        {client.name}
                      </option>
                    ))}
                  </select>
                  {errors.clients && (
                    <div className="invalid-feedback">
                      {errors.clients.message}
                    </div>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">Role Manager *</label>
                  <select
                    className={`form-select searchable-select ${
                      errors.roleManagers ? "is-invalid" : ""
                    }`}
                    {...register("roleManagers", {
                      required: "Role Manager is required",
                    })}
                  >
                    <option value="">-- Select Role Manager --</option>
                    {roleManagers.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.role_manager}
                      </option>
                    ))}
                  </select>
                  {errors.roleManagers && (
                    <div className="invalid-feedback">
                      {errors.roleManagers.message}
                    </div>
                  )}
                </div>
              </div>

              {/* Country + Region */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">Job Location Country *</label>
                  <select
                    className={`form-select searchable-select ${
                      errors.countries ? "is-invalid" : ""
                    }`}
                    {...register("countries", {
                      required: "Country is required",
                    })}
                    onChange={handleCountryChange}
                  >
                    <option value="">-- Select Country --</option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.id}>
                        {country.name}
                      </option>
                    ))}
                  </select>

                  {errors.countries && (
                    <div className="invalid-feedback">
                      {errors.countries.message}
                    </div>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">Region *</label>
                  <select
                    className={`form-select ${
                      errors.filteredRegions ? "is-invalid" : ""
                    }`}
                    {...register("filteredRegions", {
                      required: "Region is required",
                    })}
                  >
                    <option value="">-- Select Region --</option>
                    {filteredRegions.map((region) => (
                      <option key={region.id} value={region.id}>
                        {region.name}
                      </option>
                    ))}
                  </select>

                  {errors.filteredRegions && (
                    <div className="invalid-feedback">
                      {errors.filteredRegions.message}
                    </div>
                  )}
                </div>
              </div>

              {/* Major Function + Function */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">Major Function *</label>
                  <select
                    className={`form-select searchable-select ${
                      errors.dutymasters ? "is-invalid" : ""
                    }`}
                    {...register("dutymasters", {
                      required: "Major function is required",
                    })}
                    onChange={handleDutymasterChange}
                  >
                    <option value="">-- Select Major Function --</option>
                    {dutymasters.map((dm) => (
                      <option key={dm.id} value={dm.id}>
                        {dm.name}
                      </option>
                    ))}
                  </select>

                  {errors.dutymasters && (
                    <div className="invalid-feedback">
                      {errors.dutymasters.message}
                    </div>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">Function *</label>
                  <select
                    className={`form-select searchable-select ${
                      errors.filteredDuties ? "is-invalid" : ""
                    }`}
                    {...register("filteredDuties", {
                      required: "Function is required",
                    })}
                  >
                    <option value="">-- Select Function --</option>
                    {filteredDuties.map((duty) => (
                      <option key={duty.id} value={duty.id}>
                        {duty.name}
                      </option>
                    ))}
                  </select>

                  {errors.filteredDuties && (
                    <div className="invalid-feedback">
                      {errors.filteredDuties.message}
                    </div>
                  )}
                </div>
              </div>

              {/* Role Responsibilities (Full Width) */}
              <div className="mb-3">
                <label className="form-label">Role Responsibilities *</label>
                <textarea
                  rows="4"
                  className="form-control"
                  placeholder="Enter job description"
                  {...register("description", {
                    required: "Role responsibilities are required",
                  })}
                ></textarea>
                {errors.description && (
                  <div className="invalid-feedback">
                    {errors.description.message}
                  </div>
                )}
              </div>

              {/* Key Attributes */}
              <div className="mb-3">
                <label className="form-label d-block">
                  Role Key Attributes *
                </label>
                {keyAttributes.map((field, index) => (
                  <div
                    key={field.id}
                    className="d-flex align-items-center mb-2"
                  >
                    <input
                      className="form-control me-2"
                      placeholder="Enter key attribute"
                      {...register(`key_attributes.${index}.value`, {
                        required: "This field is required",
                      })}
                    />
                    {index >= 3 && (
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => remove(index)}
                        title="Delete"
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    )}
                  </div>
                ))}

                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm mt-2"
                  onClick={() => append({ value: "" })}
                >
                  Add Key Role Criteria
                </button>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-success">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddSearchProposal;
